import React, { useState } from "react";
import VehicleIaaIAndCopart from "../VehicleIaaIAndCopart";
import { Alert, Spinner } from "react-bootstrap";
import { useGetCarsQuery } from "../../redux/createApi";

const VehicleFind = () => {
  const [page, setPage] = useState(1);
  const size = 12;

  const { data, isLoading, error } = useGetCarsQuery({ page, size, site: 1 });

  if (isLoading) {
    return (
      <div className="text-center my-4">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2">Loading cars...</p>
      </div>
    );
  }

  if (error) {
    return (
      <Alert variant="danger" className="mt-4 text-center">
        <Alert.Heading>Oops! Something went wrong.</Alert.Heading>
        <p>We couldn't fetch the cars at the moment. Please try again later.</p>
        {error?.status && <hr />}
        <p className="mb-0">
          <strong>Error Code:</strong> {error?.status}
        </p>
      </Alert>
    );
  }

  return (
    <>
      {/* 22-04-2025 After Code */}
      <VehicleIaaIAndCopart
        vehicles={data?.data}
        totalItems={data?.count}
        page={page}
        setPage={setPage}
        size={size}
      />
    </>
  );
};

export default VehicleFind;
